import {Check} from './Check';

export class OnfidoRef{
    id: string;
    checks: Check[];
}